<template>
  <div>
    <Breadcrumbs :title="$t('lbl_EMPBE_AdInfoCenter')" />
    <visitorPermission>
      <template v-slot:body>
        <div class="container-fluid">
          <div class="email-wrap bookmark-wrap">
            <div class="row">
              <div class="col-12 box-col-6">
                <div class="email-left-aside">
                  <div v-if="isShowAdOverview" class="d-flex my-4 AdsMainTab">
                    <a
                      @click="TabClick(0)"
                      :class="{ 'text-secondary': CurrentMainTab != 0 }"
                      :t_label="adTLabel('Main', 'tabOverView')"
                    >
                      {{ $t("lbl_EMPBE_AdsOverView") }}
                    </a>
                    <a
                      @click="TabClick(1)"
                      :class="{ 'text-secondary': CurrentMainTab != 1 }"
                      :t_label="adTLabel('Main', 'tabByAdCategory')"
                    >
                      {{ $t("lbl_EMPBE_ByAdCategory") }}
                      <span v-if="toBeSubmittedCount" class="ad-pending-badge">{{ toBeSubmittedCount }}</span>
                    </a>
                    <b-button class="AddAdsItem" variant="primary" v-b-toggle.learnMore_Sidebar>
                      <i class="fa fa-plus"></i>
                      {{ $t("lbl_EMPBE_FullAdvertisingOptions") }}
                    </b-button>
                  </div>

                  <div v-if="isShowAdOverview" v-show="CurrentMainTab == 0">
                    <overview @JumpToAds="JumpToAds" class="p-l-30 p-r-30"></overview>
                  </div>

                  <div v-show="CurrentMainTab == 1">
                    <router-view @list-loaded="onListLoaded" />
                  </div>

                  <b-sidebar
                    sidebar-class="imgSidebar"
                    id="learnMore_Sidebar"
                    :title="$t('lbl_EMPBE_LearnMore')"
                    right
                    bg-variant="white"
                    :shadow="true"
                    backdrop
                  >
                    <div class="tab-pane active">
                      <div class="card shadow-none">
                        <div class="card-body text-center m-l-15" ref="cardbody">
                          <b-button
                            :href="'https://cdn.adsalecdn.com/EMP/Backend/pdf/EPO_Brochure_EMP_' + langid + '.pdf'"
                            v-bind:t_label="'EMPBE_Ad_BtnDownloadEMPEPO'"
                            target="_blank"
                            variant="dark"
                            class="p-0"
                            style="height: 500px;width:355px;"
                            @mouseover="upHere = true"
                            @mouseleave="upHere = false"
                          >
                            <div class="d-flex align-items-center w-100 h-100 flex-column justify-content-center">
                              <div v-show="upHere" style="position: absolute;">
                                <i class="m-3 f-50 fa fa-file-pdf-o txt-white"></i><br />
                                <span class="f-16">{{ $t("lbl_EMPBE_AdLearnMorePDF") }}</span>
                              </div>
                              <img
                                class="h-100"
                                :class="{ op01: upHere }"
                                :src="'https://cdn.adsalecdn.com/EMP/Backend/Images/' + langid + '/empEpoFilePage1.png?version=2'"
                                :alt="$t('lbl_EMPBE_AdLearnMorePDF')"
                              />
                            </div>
                          </b-button>
                          <div class="text-left f-16 m-3">
                            <div v-html="$t('lbl_EMPBE_AdLearnMoreEnquiry')"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-sidebar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </visitorPermission>
  </div>
</template>

<script>
import { AlertDialog } from "@/_helpers/AlertDialog";
import overview from "./overview/page.vue";
import { isShowAdOverview } from "../../constants/config";
import { clearAdDetailNavContext } from "./adDetailNavContext";
import { buildAdInfoCenterTLabel, resolveAdInfoCenterTrackingRoleId } from "./adDisplayConfig";

export default {
  name: "AdvertismentInfoCenter",
  mixins: [AlertDialog],
  components: {
    overview,
  },
  data() {
    return {
      isShowAdOverview: isShowAdOverview,
      CurrentMainTab: isShowAdOverview ? 0 : 1,
      upHere: false,
      toBeSubmittedCount: 0,
    };
  },
  computed: {
    companyId() {
      return this.$store.state.authentication.user.empCompanyId;
    },
    trackingRoleId() {
      return resolveAdInfoCenterTrackingRoleId(this.$store);
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query.tab
          || route.name === "AdvertismentInfoCenterDetail"
          || route.name === "AdvertismentInfoCenterDetailById") {
          this.CurrentMainTab = 1;
        }
      },
    },
  },
  methods: {
    adTLabel(location, action) {
      return buildAdInfoCenterTLabel(location, action, this.companyId, this.trackingRoleId);
    },
    TabClick(tabId) {
      this.CurrentMainTab = tabId;
      if (tabId === 1
        && (this.$route.name === "AdvertismentInfoCenterDetail"
          || this.$route.name === "AdvertismentInfoCenterDetailById")) {
        this.$router.push({ name: "AdvertismentInfoCenter" });
      }
    },
    JumpToAds(adsTabId) {
      const pageTypes = [
        "bannerAd",
        null,
        "buttonAd",
        "landingAd",
        "videoAd",
        "starAd",
        "catListAd",
        "priorityAd",
      ];
      const pageType = pageTypes[adsTabId];
      this.CurrentMainTab = 1;
      this.$router.push({
        name: "AdvertismentInfoCenter",
        query: pageType ? { tab: pageType } : {},
      });
    },
    btnSubmit_Click() {
      this.$swal({
        title: this.$t("lbl_EMPBE_Ad_Submit_Title"),
        text: this.$t("lbl_EMPBE_Ad_Submit_Text"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Ad_Submit_Save"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        customClass: "ad-svc-popup-save",
        reverseButtons: true,
      }).then(async (res) => {
        if (res.isConfirmed) {
          await this.$refs["tab" + this.currentTab].btnSubmit_Click();
          await this.GetAdStatus();
        }
      });
    },
    onListLoaded({ toBeSubmittedCount }) {
      this.toBeSubmittedCount = toBeSubmittedCount || 0;
    },
    OpenPowerText(currentTab) {
      /* Comment by Isaac Request 20260303[WHS]
      // Only show pending restriction in Priority Ad and Top Ad
      if ((currentTab == 6 || currentTab == 7) && this.statusCode == "P") {
        //Show Alert
        this.$swal({
          title: this.$t("lbl_EMPBE_Ad_Pending_Restriction_Title"),
          text: this.$t("lbl_EMPBE_Ad_Pending_Restriction_Desc"),
          showCancelButton: false,
          confirmButtonText: this.$t("lbl_EMPBE_ReportAll_component_Import_OK"),
          customClass: "ad-svc-popup",
        })
      }
      */
    },
    TabClick(TabID) {
      this.CurrentMainTab = TabID
    },
    JumpToAds(AdsTabID) {
      this.CurrentMainTab = 1 //Jump main tab to ads
      this.currentTab = AdsTabID
    },
    GetAdsDisplayOption() {
      var parms = {
        LangId: this.langid,
        CompanyId: this.companyid,
      };
      //[04122023][SJP] Get Company's industry/category
      //应用行业
      productService.GetIndustryByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          this.AdsDisplayOption.App = dataList.map(x => ({ value: x.id, text: x.label }));
        }
      });
      //产品类别
      productService.GetProductCatByCompanyId(parms).then((response) => {
        if (response.isSuccessful) {
          var dataList = response.data;
          this.AdsDisplayOption.Cat = dataList.map(x => ({ value: x.id, text: x.label }));
        }
      }); // end 加载品类

      var parms2 = {
        LangId: this.langid,
      };
      //加载热搜标签
      productService.GetAdSearchKeyword(parms2).then((res) => {
        if (res.isSuccessful) {
          this.options = [];
          for (let index = 0; index < res.data.length; index++) {
            var item = {
              value: res.data[index].searchId,
              text: res.data[index].text,
            };
            this.AdsDisplayOption.Keyword_Options.push(item);
          }


        }
      });
    },
    async SubmitAdsDisplayChange(CurrentRID, CurAdsSearchByObj, CurAdsSearchByType) {
      var inputParam = {
        RID: CurrentRID,
        AdsSearchByObj: CurAdsSearchByObj,
        CompanyId: this.companyid,
        AdsSearchByType: CurAdsSearchByType
      }

      try {
        const res = await productService.UpdateAdsDisplay(inputParam);
        return res.isSuccessful;
      } catch (error) {
        console.error(error);
        throw error;
      }


    }
  },
  beforeRouteLeave(to, from, next) {
    const finishLeave = () => {
      clearAdDetailNavContext();
      next();
    };
    if (this.$store.state.dirty) {
      this.showLeavePage().then((result) => {
        if (result.isConfirmed) {
          this.$store.state.dirty = false;
          finishLeave();
        }
      });
    } else {
      finishLeave();
    }
  },
};
</script>

<style lang="scss" scoped>
.AdsMainTab>a {
  font-family: Roboto;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0px 30px 0px 30px;
  color: black;
  cursor: pointer;

  &:not(:first-child) {
    border-left: 1px solid #CDCDCD
  }

  &:hover {
    color: black
  }
}

.ad-pending-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: #e53935;
  border-radius: 11px;
  vertical-align: middle;
}

.AddAdsItem {
  margin-left: auto;
  height: 80%;
  margin-right: 40px;
  margin-top: auto;
  margin-bottom: auto;
}

.container-fluid {
  margin-bottom: 15px;
}
</style>
